'use strict';

var BootstrapInterceptorConfig = function BootstrapInterceptorConfig($httpProvider) {
  $httpProvider.interceptors.push('ParseCookieToHeaderFactory');
  $httpProvider.interceptors.push('HttpRequestInterceptorFactory');
};
BootstrapInterceptorConfig.$inject = ['$httpProvider'];
module.exports = BootstrapInterceptorConfig;